import { ADD_CATEGORIES } from "./categoryActionsType";
import { url } from "../../helper";

export const CategoryActionCreators = {
    addCategory: (categories) => ({
        type: ADD_CATEGORIES,
        payload: categories,
    }),
};
